import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { makeResetCache, useCacheQuery } from 'gossamer-front-end';
import { BookingView, BookingExtendedView } from 'cb-model';
import { QueryOptions } from 'gossamer-unified';

export type BookingExistence = 'not_exists' | 'exists' | 'timed_out';

export const useBookingExists = (
  eventId: number | null | undefined,
  userId: string | null | undefined,
  poll?: boolean,
) => {
  const [bookingExistence, setBookingExistence] = useState<BookingExistence>('not_exists');
  const bookingQueryOptions: QueryOptions | null =
    eventId && userId
      ? {
          where: {
            and: [
              { fieldId: 'user_id', operator: 'eq', value: userId },
              { fieldId: 'event_id', operator: 'eq', value: eventId },
              { fieldId: 'booking_status', operator: 'eq', value: 'active' },
            ],
          },
          limit: 1,
        }
      : null;
  const bookingQuery = useCacheQuery(BookingView, (bookingQueryOptions ?? {}) as QueryOptions, !bookingQueryOptions);
  const dispatch = useDispatch();

  // Once we know payment succeeded, poll booking status for up to 30s.
  useEffect(() => {
    if (!poll) {
      return;
    }

    makeResetCache(dispatch)(BookingView.id);
    makeResetCache(dispatch)(BookingExtendedView.id);

    const start = Date.now();
    const interval = window.setInterval(() => {
      if (Date.now() - start > 30_000) {
        setBookingExistence('timed_out');
        window.clearInterval(interval);
        return;
      }
      console.log('inside useBookingExists() interval, resetting booking cache');
      makeResetCache(dispatch)(BookingView.id);
      makeResetCache(dispatch)(BookingExtendedView.id);
    }, 2000);

    return () => {
      window.clearInterval(interval);
    };
  }, [dispatch, poll]);

  useEffect(() => {
    if (bookingExistence === 'not_exists' && (bookingQuery.data?.length ?? 0) > 0) {
      setBookingExistence('exists');
    }
  }, [bookingQuery.data]);

  return bookingExistence;
};
